import { __assign, __awaiter, __generator } from "tslib";
import { forEachBatch } from '@office-start/batch-utility';
import { encrypt } from '@office-start/encryption-utility';
import { IDLE_VERYLOW_PRIORITY, scheduleWork, } from '@office-start/scheduler-service';
import { utf8Encode } from '@office-start/text-encoding-utility';
import { writeItemsToCache } from './writeItemsToCache';
export function encryptFiles(files, cryptoKey) {
    return __awaiter(this, void 0, void 0, function () {
        var encryptedFiles, batchedWrites_1, _err_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 3, , 4]);
                    return [4 /*yield*/, Promise.all(files.map(function (file) {
                            return new Promise(function (resolveEncrypt, rejectEncrypt) {
                                scheduleWork(function () {
                                    var item = __assign(__assign({}, file), { indexed: false });
                                    var partialCacheEntry = {
                                        id: item.id,
                                        useractions_datetime: item.useractions_datetime,
                                        useractions_datetime_inverse_time_in_ms: item
                                            .useractions_datetime_inverse_time_in_ms,
                                    };
                                    if (cryptoKey) {
                                        utf8Encode(JSON.stringify(item))
                                            .then(function (encodedBytes) {
                                            return encrypt(encodedBytes.buffer, cryptoKey);
                                        })
                                            .then(function (buffer) {
                                            resolveEncrypt(__assign(__assign({}, partialCacheEntry), { item: buffer }));
                                        })
                                            .catch(rejectEncrypt);
                                    }
                                    else {
                                        resolveEncrypt(__assign(__assign({}, partialCacheEntry), { item: item }));
                                    }
                                }, IDLE_VERYLOW_PRIORITY);
                            });
                        }))];
                case 1:
                    encryptedFiles = _a.sent();
                    batchedWrites_1 = [];
                    forEachBatch(encryptedFiles, 10, function (batchedItems) {
                        batchedWrites_1.push(new Promise(function (resolveWrite, rejectWrite) {
                            scheduleWork(function () {
                                writeItemsToCache(batchedItems)
                                    .then(resolveWrite)
                                    .catch(rejectWrite);
                            }, IDLE_VERYLOW_PRIORITY);
                        }));
                    });
                    return [4 /*yield*/, Promise.all(batchedWrites_1)];
                case 2:
                    _a.sent();
                    return [3 /*break*/, 4];
                case 3:
                    _err_1 = _a.sent();
                    // TODO: Instrumentation for encryption errors
                    return [2 /*return*/, false];
                case 4: return [2 /*return*/, true];
            }
        });
    });
}
//# sourceMappingURL=encryptFiles.js.map